export enum batchWebhookType {
  batchOnly = "batchOnly",
  singleAndBatch = "singleAndBatch",
  singleOnly = "singleOnly",
}
